const config = {
  remotes: {},
  serviceContext: process.env.REACT_APP_SERVICE_CONTEXT,
  serviceUri: process.env.REACT_APP_SERVICE_URI,
  downloadUri: process.env.REACT_APP_DOWNLOAD_URI,
  // this needs to match with other web-ui microservices
  tokenKey: process.env.REACT_APP_TOKEN_KEY || 'Lite::Token',
  baIdKey: process.env.REACT_APP_BAID_KEY || 'Lite::BaId',
  // Short date pattern
  formatDateTimeShortDate: process.env.FORMAT_DATETIME_SHORTDATE || 'YYYY-MM-DD',
  // Long date pattern
  formatDateTimeLongDate: process.env.FORMAT_DATETIME_LONGDATE || 'MMMM DD, YYYY',
  // Full date/time pattern (short time)
  formatDateTimeShortTime: process.env.FORMAT_DATETIME_SHORTTIME || 'YYYY-MM-DD H:mm:ss',
  // Full date/time pattern (long time)
  formatDateTimeLongTime: process.env.FORMAT_DATETIME_LONGTIME || 'YYYY-MM-DD h:mm:ss A z',
  // Client time zone
  formatDateTimeClientTimezone: process.env.FORMAT_DATETIME_CLIENT_TIMEZONE || 'America/Edmonton',
  maxReviewCommentCharCount: 2000,
}

console.log('Config', config)
console.log('Environment variables', process.env)

export default config
export const remotes = config.remotes
export const serviceUri = config.serviceUri

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
}
export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
}
